import { render, staticRenderFns } from "./Similarity.vue?vue&type=template&id=1e821271&"
import script from "./Similarity.vue?vue&type=script&lang=ts&"
export * from "./Similarity.vue?vue&type=script&lang=ts&"
import style0 from "./Similarity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports